import React from "react"

const Error401 = () => {
  return (
    <div className="p-grid">
      <div className="p-col-12 text-center">
        <h1>HTTP Error 401: Unauthorized Access</h1>
      </div>
      <div className="p-col-12 text-center">
        <h3>Sorry, authorization required!</h3>
        <p>You have attempted to access a page for which you are not authorized.</p>
      </div>
    </div>
  )
}

export default Error401


// WEBPACK FOOTER //
// ./src/components/common/Error401.js